<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">New Warehouse</h4>
                        <h6 class="card-subtitle">Add a Warehouse.</h6>
                    </div>
                    <form class="form-horizontal" @submit.prevent="handleSubmit">
                        <div class="card-body card-blue">
                            <h6 class="card-title">Warehouse Info</h6>

                            <div class="form-group row">
                                <label for="warehouse_name" class="col-sm-3 text-right control-label col-form-label">Warehouse Name</label>
                                <div class="col-sm-5">
                                    <input type="text" class="form-control"
                                           id="warehouse_name"
                                           name="warehouse_name"
                                           v-validate="'required'"
                                           data-vv-as="Warehouse Name"
                                           v-model="warehouse.name"
                                           :class="{'is-invalid': submitted && errors.has('warehouse_name')}"
                                           placeholder="Name">
                                    <small class="form-text text-muted">This is how others will identify your warehouse</small>
                                    <div v-if="submitted && errors.has('warehouse_name')" class="invalid-feedback">{{ errors.first('warehouse_name') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="description" class="col-sm-3 text-right control-label col-form-label">Description</label>
                                <div class="col-sm-5">
                                    <textarea type="text"
                                              class="form-control"
                                              id="description"
                                              name="description"
                                              data-vv-as="Description"
                                              v-model="warehouse.description"
                                              :class="{'is-invalid': submitted && errors.has('description')}"
                                              rows=4
                                              placeholder="Description">
                                    </textarea>
                                    <div v-if="submitted && errors.has('description')" class="invalid-feedback">{{ errors.first('description') }}</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="attachment" class="col-sm-3 text-right control-label col-form-label">Attachment</label>
                                <div class="col-sm-5">
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input type="file"
                                                   id="attachment"
                                                   name="attachment"
                                                   v-validate=""
                                                   ref="file"
                                                   data-vv-as="Attachment"
                                                   :class="{'is-invalid': submitted && errors.has('attachment')}"
                                                   class="custom-file-input"
                                                   v-on:change="onFileChange()"
                                                   accept=".JPG,.JPEG,.PNG">
                                            <label class="custom-file-label">{{filename}}</label>
                                        </div>
                                    </div>
                                    <small class="form-text text-muted">{{uploadstatus}}</small>
                                    <div v-if="submitted && errors.has('attachment')" class="invalid-feedback">{{ errors.first('attachment') }}</div>
                                </div>
                            </div>

                        </div>


                        <div class="card-body card-blue">
                            <h6 class="card-title">Warehouse Address</h6>

                            <div class="form-group row">
                                <label for="line1" class="col-sm-3 text-right control-label col-form-label">Address</label>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control"
                                           id="line1"
                                           name="line1"
                                           v-model="warehouse.address.line1"
                                           v-validate="'required'"
                                           data-vv-as="Address Line 1"
                                           :class="{'is-invalid': submitted && errors.has('line1')}"
                                           placeholder="Address Line 1">
                                    <div v-if="submitted && errors.has('line1')" class="invalid-feedback">{{ errors.first('line1') }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control"
                                           id="line2"
                                           name="line2"
                                           v-model="warehouse.address.line2"
                                           data-vv-as="Address Line 2"
                                           :class="{'is-invalid': submitted && errors.has('line2')}"
                                           placeholder="Address Line 2">
                                    <div v-if="submitted && errors.has('line2')" class="invalid-feedback">{{ errors.first('line2') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="city" class="col-sm-3 text-right control-label col-form-label"></label>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control"
                                           id="city"
                                           name="city"
                                           v-model="warehouse.address.city"
                                           v-validate="'required'"
                                           data-vv-as="City"
                                           :class="{'is-invalid': submitted && errors.has('city')}"
                                           placeholder="City">
                                    <div v-if="submitted && errors.has('city')" class="invalid-feedback">{{ errors.first('city') }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control"
                                           id="state"
                                           name="state"
                                           v-model="warehouse.address.state"
                                           v-validate="'required'"
                                           data-vv-as="State"
                                           :class="{'is-invalid': submitted && errors.has('state')}"
                                           placeholder="State or Province">
                                    <div v-if="submitted && errors.has('state')" class="invalid-feedback">{{ errors.first('state') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="postal_code" class="col-sm-3 text-right control-label col-form-label"></label>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control"
                                           id="postal_code"
                                           name="postal_code"
                                           v-model="warehouse.address.postal_code"
                                           v-validate="'required'"
                                           data-vv-as="Postal Code"
                                           :class="{'is-invalid': submitted && errors.has('postal_code')}"
                                           placeholder="Postal Code">
                                    <div v-if="submitted && errors.has('postal_code')" class="invalid-feedback">{{ errors.first('postal_code') }}</div>
                                </div>
                                <div class="col-sm-4">
                                    <multiselect id="country"
                                                 name="country"
                                                 class="form-control"
                                                 v-model="selectedCountry"
                                                 :options="countries"
                                                 label="name"
                                                 :allow-empty="true"
                                                 placeholder="Select country"
                                                 v-validate="'required'"
                                                 data-vv-as="Country"
                                                 track-by="code"
                                                 :class="{'is-invalid': submitted && errors.has('country')}">
                                        <span class="multiselect__placeholder">Type to search</span>
                                    </multiselect>

                                    <div v-if="submitted && errors.has('country')" class="invalid-feedback">{{ errors.first('country') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button type="submit" class="btn waves-effect waves-light btn-success">Save</button>
                                    <button type="button" @click="reset()" class="btn waves-effect waves-light btn-secondary">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import countries from "../../../../assets/js/countries";
    import uuid from 'uuid/v4';
    import axios from 'axios';

    export default {
        name: "AddWarehouse",
        components: {Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                countries: countries,
                selectedCountry: null,
                file: File,
                filename: "No File Chosen",
                warehouse: {
                    id: null,
                    name: '',
                    description: '',
                    warehouse_props: null,
                    attachments: [],
                    address: {
                        line1: '',
                        line2: '',
                        city: '',
                        state: '',
                        postal_code: '',
                        country: '',
                        country_code: ''
                    }
                },
                uploadstatus: ''
            };
        },
        mounted() {
            this.warehouse.id = uuid();
        },
        methods: {
            save() {
                this.warehouse.address.country      = this.selectedCountry.name;
                this.warehouse.address.country_code = this.selectedCountry.code;

                this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, this.warehouse)
                .then(reply => {
                    this.$router.push({name: "warehouses", params: {marketplaceid: this.currentOrg.marketplace_id}});
                    this.$toastr('success', 'Warehouse added successfully.', 'Warehouse Added');
                })
                .catch(err => {
                    console.log(err)
                });
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            reset() {
                this.selectedCountry = {
                    code: '',
                    name: ''
                };
                this.warehouse       = {
                    name: '',
                    description: '',
                    warehouse_props: null,
                    attachments: [],
                    address: {
                        line1: '',
                        line2: '',
                        city: '',
                        state: '',
                        postal_code: '',
                        country: '',
                        country_code: ''
                    }
                }
            },
            async onFileChange() {
                this.uploadstatus          = 'Uploading file, please wait ...';
                this.file                  = this.$refs.file.files[0];
                this.filename              = this.file.name;
                let signedurl              = await this.getUploadUrl(this.warehouse.id, this.filename);
                let uploaded               = await this.uploadFile(signedurl.data.url);
                this.warehouse.attachments = [];
                this.warehouse.attachments.push({
                    filename: this.filename,
                    filepath: signedurl.data.key,
                    contenttype: this.file.type.split('/')[1]
                });
                this.$refs.file.value = '';
                this.uploadstatus     = 'File uploaded'
            },
            async getUploadUrl(warehouseId, filename) {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${warehouseId}/signedUrl`, {
                    params: {
                        name: filename,
                        type: 'write'
                    }
                });
                return signedUrl;
            },
            async getDownloadUrl(index) {
                let filepath = this.warehouse.attachments[index].filepath;
                let result   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouse.id}/signedUrl`, {
                    params: {
                        type: 'read',
                        key: filepath
                    }
                });

                window.location.href = result.data.url;
            },
            async removeAttachment(index) {
                this.warehouse.attachments = [];
                this.filename              = "No File Chosen";
            },
            async uploadFile(signedUrl) {
                await axios.put(signedUrl, this.file);
            }
        }
    }
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }
</style>
